import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BlueButton } from "../../../components/attributes/Button";
import { BottomBar } from "../../../components/bar/Bottom.Bar";
import Container from "../../../components/layouts/Container";
import WrapperMiddleScreen from "../../../components/layouts/WrapperMiddleScreen";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_LOG_IN,
  TEXT_MY_PROFILE,
  TEXT_PLEASE,
  TEXT_TO_YOUR_PROFILE,
} from "../../../utils/useConstants";
import { STATE_CONSTANTS_PROFILE } from "../../../utils/useConstantState";
import { ICON_EMPTY_ADDRESS } from "../../../utils/useIcons";
import {
  STYLE_ADDRESS_BG,
  STYLE_BOTTOM_MIN_H_FULL,
  STYLE_HEIGHT_BAR,
  STYLE_IMG_EMPTY,
  STYLE_IMG_EMPTY_BASKET,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_MIN_H_FULL,
  STYLE_PADDING_NO_MB,
  STYLE_PADDING_READING,
  STYLE_SCREEN_FULL,
  STYLE_SEMIBOLD_BLUE,
  STYLE_TEXT_EMPTY_PROFILE,
  STYLE_TEXT_PROGRAM_BACK,
  STYLE_WIDTH_PROGRAM_BACK,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";

const ProfileBeforeLogin = ({ setTab }) => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  const location = useLocation();
  return (
    <div className={STYLE_SCREEN_FULL}>
      <Container>
        <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
          <div
            className={`${STYLE_ADDRESS_BG} mb-[30px] md:mb-0`}
            id="scroll_login"
          >
            <div>
              <ProgramGoBack
                onClick={() => {
                  navigate("/");
                }}
                title={TEXT_MY_PROFILE[language]}
              />
              <img
                src="/images/empty_profile.png"
                className={STYLE_IMG_EMPTY_BASKET}
              />
              <div className={`${STYLE_TEXT_EMPTY_PROFILE(language)}`}>
                {TEXT_PLEASE[language]}{" "}
                <span
                  onClick={() => {
                    sessionStorage.setItem("redirect", location.pathname);
                    navigate("/Login");
                  }}
                  className={`${STYLE_LINK_BLUE} mx-1`}
                >
                  {TEXT_LOG_IN[language]}
                </span>{" "}
                {TEXT_TO_YOUR_PROFILE[language]}
              </div>
            </div>
          </div>
        </div>
      </Container>

      <BottomBar
        title={TEXT_LOG_IN[language]}
        classNameBottomBar={STYLE_HEIGHT_BAR}
        onClick={() => {
          sessionStorage.setItem("redirect", location.pathname);
          navigate("/Login");
        }}
      />
    </div>
  );
};

export default ProfileBeforeLogin;
